"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m15.99 6.22-5.916-.06L7.965.71 5.856 6.13 0 6.15l4.617 3.8-1.379 5.32 4.727-3.18 4.707 3.17-1.31-5.28L16 6.22V6.2l-.01.02Zm-5.756 3.4.84 3.37-3.109-2.09-3.098 2.08.88-3.39-2.969-2.45h3.768l1.479-3.81s1.38 3.57 1.489 3.81l3.718.04-2.998 2.43v.01Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m23.977 9.36-8.88-.09-3.172-8.167L8.76 9.24l-8.753.03 6.9 5.685-2.062 7.943 7.072-4.763 7.058 4.747L17.017 15l6.96-5.647v.007Zm-6.795 10.957-5.257-3.54-5.235 3.525 1.5-5.767-5.048-4.155 6.398-.023 2.392-6.15 2.4 6.173 6.518.067-5.093 4.133 1.425 5.737Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m31.97 12.48-11.84-.12L15.9 1.47l-4.22 10.85-11.67.04 9.2 7.58-2.75 10.59 9.43-6.35 9.41 6.33L22.69 20l9.28-7.53v.01Zm-9.06 14.61-7.01-4.72-6.98 4.7 2-7.69-6.73-5.54 8.53-.03 3.19-8.2 3.2 8.23 8.69.09-6.79 5.51 1.9 7.65Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m47.947 18.735-17.7-.18-6.36-16.372-6.337 16.312-17.505.06 13.807 11.37L9.727 45.81l14.16-9.532 14.13 9.51-3.922-15.765 13.852-11.235v-.06.007Zm-15.96 10.59 3.03 12.188L23.88 34.02l-11.1 7.47 3.18-12.247-10.718-8.828 13.59-.052 5.055-13.005 5.07 13.057 13.838.143-10.808 8.76v.007Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m63.93 24.98-23.6-.24-8.48-21.83-8.45 21.75-23.34.08L18.47 39.9l-5.5 21.18 18.88-12.71 18.84 12.68-5.23-21.02 18.47-14.98v-.08.01ZM42.65 39.1l4.04 16.25-14.85-9.99-14.8 9.96 4.24-16.33L6.99 27.22l18.12-.07 6.74-17.34 6.76 17.41 18.45.19-14.41 11.68v.01Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconRatingsStarUnfilled = function IconRatingsStarUnfilled(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Ratings Star Unfilled' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "RatingsStarUnfilled"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconRatingsStarUnfilled.sizes = [16, 24, 32, 48, 64];
IconRatingsStarUnfilled.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconRatingsStarUnfilled;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/RatingsStarUnfilled.js
// module id = 1837
// module chunks = 0